export default {"src":"/_next/static/media/SBRA.003bef4f.svg","height":18,"width":18};